/* eslint-disable @typescript-eslint/camelcase */
import { OTHER_LOGIN_PROVIDERS, Providers } from '../constants/providers';
import { INITIAL_CREDROW } from '@card/types';
var hasOtherLogin = function (country, credential) {
    return OTHER_LOGIN_PROVIDERS[country].includes(credential.info_provider);
};
var toCredentialsRow = function (cred) {
    var unassignedEstabs = 0;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var formatEstablishments = cred.establishments.map(function (estab) {
        estab.status = 'OK';
        if (!estab.shop_id)
            unassignedEstabs++;
        return estab;
    });
    var status = cred.status && cred.status.toUpperCase();
    return {
        automatic_renewal: cred.automatic_renewal,
        info_provider: Providers[cred.info_provider.toUpperCase()],
        info_provider_api: cred.info_provider,
        status: 'CREATED',
        apiStatus: status,
        error: 'NULL',
        username: cred.username,
        other_login: cred.other_login,
        password: INITIAL_CREDROW.password,
        credential_id: cred.id,
        establishments: formatEstablishments,
        has_unassigned_estabs: unassignedEstabs !== 0
    };
};
export var CredentialUtils = { hasOtherLogin: hasOtherLogin, toCredentialsRow: toCredentialsRow };
